import React, { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { createBrowserHistory } from "history"
import { CircularProgress } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { index } from './store/actions/app.action'

const Auth = lazy(() => import('./view/auth'))
const Campaigns = lazy(() => import('./view/desktop/campaigns'))
const Closed = lazy(() => import('./view/desktop/campaigns/closed'))
const Metrics = lazy(() => import('./view/desktop/metrics'))
const MetricsRegion = lazy(() => import('./view/desktop/metrics/region'))
const MetricsUtms = lazy(() => import('./view/desktop/metrics/utms'))
const Links = lazy(() => import('./view/desktop/links'))
const EditLink = lazy(() => import('./view/desktop/links/edit'))
const Pixel = lazy(() => import('./view/desktop/pixel'))
const EditPixel = lazy(() => import('./view/desktop/pixel/edit'))
const Utms = lazy(() => import('./view/desktop/utms'))
const Google = lazy(() => import('./view/desktop/google'))
const EditGoogle = lazy(() => import('./view/desktop/google/edit'))
const Password = lazy(() => import('./view/desktop/password'))
const Webhook = lazy(() => import('./view/desktop/webhooks'))
const EditWebhook = lazy(() => import('./view/desktop/webhooks/edit'))

const ChartCampaigns = lazy(() => import('./view/desktop/campaigns/chart'))
const ChartCampaign = lazy(() => import('./view/desktop/campaigns/chart/campaign'))

const ChartLinks = lazy(() => import('./view/desktop/links/chart'))
const ChartLink = lazy(() => import('./view/desktop/links/chart/link'))

const Routes = () => {
    const history = createBrowserHistory()
    const [loading, setLoading] = React.useState(true)
    const dispatch = useDispatch()

    React.useEffect(() => {
        if(history.location.pathname !== '/login') {
            dispatch(index()).then(res => res && setLoading(false))
        }else {
            setLoading(false)
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
        {(history.location.pathname !== '/login' && loading ) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
        <Router>
            <Suspense fallback={<div className="d-flex justify-content-center align-items-center min-vh-100"> <CircularProgress/> </div>}>
                <Switch>
        
                    <Route exact path="/webhooks/create" component={EditWebhook} />
                    <Route exact path="/webhooks/:id/edit" component={EditWebhook} />
                    <Route exact path="/webhooks" component={Webhook} />

                    <Route exact path="/pixel/create" component={EditPixel} />
                    <Route exact path="/pixel/:id/edit" component={EditPixel} />
                    <Route exact path="/pixel" component={Pixel} />
                    <Route exact path="/utms" component={Utms} />
                    <Route exact path="/google-tag-manager/create" component={EditGoogle} />
                    <Route exact path="/google-tag-manager/:id/edit" component={EditGoogle} />
                    <Route exact path="/google-tag-manager" component={Google} />
                    <Route exact path="/links/:campaign_id/create" component={EditLink} />
                    <Route exact path="/links/:campaign_id/:id/edit" component={EditLink} />
                    <Route exact path="/links/:campaign_id/:link_id/metrics" component={Metrics} />
                    <Route exact path="/links/:campaign_id" component={Links} />

                    <Route exact path="/links/:campaign_id/analysis" component={ChartLinks} />
                    <Route exact path="/links/:campaign_id/:link_id/analysis" component={ChartLink} />
                    
                    <Route exact path="/campaigns/analysis" component={ChartCampaigns} />
                    <Route exact path="/campaigns/:campaign_id/analysis" component={ChartCampaign} />
                    
                    <Route exact path="/campaigns/:campaign_id/metrics" component={Metrics} />
                    <Route exact path="/campaigns/:campaign_id/metrics/region" component={MetricsRegion} />
                    <Route exact path="/campaigns/:campaign_id/metrics/utms" component={MetricsUtms} />
					<Route exact path="/campaigns/closed" component={Closed} />
                    <Route exact path="/campaigns" component={Campaigns} />
                    <Route exact path="/password" component={Password} />
                    <Route exact path="/login" component={Auth} />
                    <Route exact path="/" component={Campaigns} />
                </Switch>
            </Suspense>
        </Router>
        }
        </>
    )
}

export default Routes;